import { useState, useEffect } from "react";
import { collection, getDocs, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import TweetItem from "./TweetItem";
import PromotionalTweet from "./PromotionalTweet";

function TweetList({ tweets, onLike, onDelete, onReply, onDeleteReply }) {
  const [promos, setPromos] = useState([]);
  const [promoPositions, setPromoPositions] = useState([]);
  const [combined, setCombined] = useState([]);

  // 🔹 Cargar promos con datos de perfil y sincronizar estado
  useEffect(() => {
  const fetchPromos = async () => {
    try {
      const promoSnapshot = await getDocs(collection(db, "PromotionalPosts"));
      const rawPromos = promoSnapshot.docs
        .map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }))
        .filter((p) => p.estado === "activo" && p.visibilidad);

      // Si quieres enriquecer con perfil
      const usersSnapshot = await getDocs(collection(db, "users"));
      const enrichedPromos = [];

      for (const promo of rawPromos) {
        let promoProfileData = null;
        for (const userDoc of usersSnapshot.docs) {
          const promoProfileRef = doc(
            db,
            `users/${userDoc.id}/promoProfiles/${promo.promoProfileId}`
          );
          const profileSnap = await getDoc(promoProfileRef);
          if (profileSnap.exists()) {
            promoProfileData = profileSnap.data();
            break;
          }
        }
        enrichedPromos.push({ ...promo, promoProfile: promoProfileData });
      }

      setPromos(enrichedPromos);

      // Barajar y fijar posiciones
      const shuffleArray = (arr) => {
        const array = [...arr];
        for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
      };

      const shuffled = shuffleArray(enrichedPromos);
      const intervals = [3, 7, 10];
      const positions = [];
      let cumulative = 0;

      shuffled.forEach((promo) => {
        const interval = intervals[Math.floor(Math.random() * intervals.length)];
        cumulative += interval;
        positions.push({ promo, position: cumulative });
      });

      setPromoPositions(positions);
    } catch (error) {
      console.error("Error cargando posts promocionales:", error);
    }
  };

  fetchPromos();
}, []);


  // 🔹 Combinar tweets + promos
  useEffect(() => {
    if (!tweets) return;

    const mappedTweets = tweets.map((t) => ({
      ...t,
      _type: "tweet",
      _date: t.date?.toDate ? t.date.toDate() : new Date(t.date),
    }));

    let combinedList = [...mappedTweets];

    promoPositions.forEach(({ promo, position }) => {
      // Solo insertar si hay suficientes tweets para llegar a esa posición.
      // Si no caben, se omiten — aparecerán cuando se carguen más tweets.
      if (position > mappedTweets.length) return;
      const pos = Math.min(position, combinedList.length);
      combinedList.splice(pos, 0, { ...promo, _type: "promo" });
    });

    setCombined(combinedList);
  }, [tweets, promoPositions]);

  return (
    <div className="space-y-4">
      {combined.map((item) =>
        item._type === "tweet" ? (
          <TweetItem
            key={item.id}
            tweet={item}
            onLike={() => onLike(item.id, item.likes)}
            onDelete={() => onDelete(item.id)}
            onReply={(text) => onReply(item.id, text)}
            onDeleteReply={(replyId) => onDeleteReply(item.id, replyId)}
          />
        ) : (
          <PromotionalTweet key={item.id} promo={item} />
        )
      )}
    </div>
  );
}

export default TweetList;
